// extracted by mini-css-extract-plugin
export default {"container":"home_container__S5Ch-","mainWrapper":"home_mainWrapper__3DH5L"};